<template>
    <div>
        <div class="ElasticBlockStoreWarning-title">
            <Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/monitor/elasticBlockStoreMonitor">{{ $t('alarms.disk.disk') }}</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.alertRule') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.common.alertRule')">
                    <div class="ElasticBlockStoreWarning-top">
                        <elastic-block-store-warning-search></elastic-block-store-warning-search>
                    </div>
                    <table-elastic-block-store-warning></table-elastic-block-store-warning>
                </TabPane>
            </Tabs>
        </template>
        
    </div>
</template>

<script>
    import ElasticBlockStoreWarningSearch from '../ebs/ElasticBlockStoreWarningSearch'
    import TableElasticBlockStoreWarning from '../ebs/TableElasticBlockStoreWarning'
    import AddOrUpdateElasticBlockStoreWarning from '../ebs/AddOrUpdateElasticBlockStoreWarning'

    export default {
        name: 'ElasticBlockStoreMonitor',
        components: {
            ElasticBlockStoreWarningSearch,
            TableElasticBlockStoreWarning,
            AddOrUpdateElasticBlockStoreWarning
        },
        data(){
            return {
                id:'',
                accountId:'',
                volumeAwsId:'',
                accountTypeName:'',
                accountName:'',
                region:''
            }
        },
        methods:{
            // 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.volumeAwsId=this.$route.query.volumeAwsId;
                this.region=this.$route.query.region;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.$router.push({path:'/monitor/elasticBlockStoreDetail/',query: {id: this.id,accountId:this.accountId,volumeAwsId:this.volumeAwsId,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
    }
</script>

<style scoped>
    .ElasticBlockStoreWarning-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .ElasticBlockStoreWarning-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/ebs/ElasticBlockStoreWarning.vue